import * as i from "react";
import { l as u, s as x, R as V, L as j } from "./contexts-CsO1QZ3r.mjs";
import { Room as U, RoomEvent as l, MediaDeviceFailure as _ } from "livekit-client";
function L(n) {
  var e, o, t = "";
  if (typeof n == "string" || typeof n == "number") t += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (e = 0; e < r; e++) n[e] && (o = L(n[e])) && (t && (t += " "), t += o);
  } else for (o in n) n[o] && (t && (t += " "), t += o);
  return t;
}
function A() {
  for (var n, e, o = 0, t = "", r = arguments.length; o < r; o++) (n = arguments[o]) && (e = L(n)) && (t && (t += " "), t += e);
  return t;
}
function I(...n) {
  return (...e) => {
    for (const o of n)
      if (typeof o == "function")
        try {
          o(...e);
        } catch (t) {
          console.error(t);
        }
  };
}
function M(...n) {
  const e = { ...n[0] };
  for (let o = 1; o < n.length; o++) {
    const t = n[o];
    for (const r in t) {
      const d = e[r], a = t[r];
      typeof d == "function" && typeof a == "function" && // This is a lot faster than a regex.
      r[0] === "o" && r[1] === "n" && r.charCodeAt(2) >= /* 'A' */
      65 && r.charCodeAt(2) <= /* 'Z' */
      90 ? e[r] = I(d, a) : (r === "className" || r === "UNSAFE_className") && typeof d == "string" && typeof a == "string" ? e[r] = A(d, a) : e[r] = a !== void 0 ? a : d;
    }
  }
  return e;
}
function J(n) {
  return n !== void 0;
}
function G(...n) {
  return M(...n.filter(J));
}
function H(n, e, o) {
  return i.Children.map(n, (t) => i.isValidElement(t) && i.Children.only(n) ? (t.props.className && (e ?? (e = {}), e.className = A(t.props.className, e.className), e.style = { ...t.props.style, ...e.style }), i.cloneElement(t, { ...e, key: o })) : t);
}
function Q(n) {
  var e, o;
  if (typeof window < "u" && typeof process < "u" && // eslint-disable-next-line turbo/no-undeclared-env-vars
  (((e = process == null ? void 0 : process.env) == null ? void 0 : e.NODE_ENV) === "dev" || // eslint-disable-next-line turbo/no-undeclared-env-vars
  ((o = process == null ? void 0 : process.env) == null ? void 0 : o.NODE_ENV) === "development")) {
    const t = document.querySelector(".lk-room-container");
    t && !getComputedStyle(t).getPropertyValue("--lk-has-imported-styles") && u.warn(
      "It looks like you're not using the `@livekit/components-styles package`. To render the UI with the default styling, please import it in your layout or page."
    );
  }
}
function T(n, e) {
  return n === "processor" && e && typeof e == "object" && "name" in e ? e.name : n === "e2ee" && e ? "e2ee-enabled" : e;
}
const q = {
  connect: !0,
  audio: !1,
  video: !1
};
function $(n) {
  const {
    token: e,
    serverUrl: o,
    options: t,
    room: r,
    connectOptions: d,
    connect: a,
    audio: p,
    video: y,
    screen: g,
    onConnected: v,
    onDisconnected: h,
    onError: c,
    onMediaDeviceFailure: b,
    onEncryptionError: E,
    simulateParticipants: w,
    ...N
  } = { ...q, ...n };
  t && r && u.warn(
    "when using a manually created room, the options object will be ignored. set the desired options directly when creating the room instead."
  );
  const [s, O] = i.useState(), C = i.useRef(a);
  i.useEffect(() => {
    O(r ?? new U(t));
  }, [r, JSON.stringify(t, T)]);
  const F = i.useMemo(() => {
    const { className: m } = x();
    return M(N, { className: m });
  }, [N]);
  return i.useEffect(() => {
    if (!s) return;
    const m = () => {
      const f = s.localParticipant;
      u.debug("trying to publish local tracks"), Promise.all([
        f.setMicrophoneEnabled(!!p, typeof p != "boolean" ? p : void 0),
        f.setCameraEnabled(!!y, typeof y != "boolean" ? y : void 0),
        f.setScreenShareEnabled(!!g, typeof g != "boolean" ? g : void 0)
      ]).catch((R) => {
        u.warn(R), c == null || c(R);
      });
    }, P = (f, R) => {
      const K = _.getFailure(f);
      b == null || b(K, R);
    }, S = (f) => {
      E == null || E(f);
    }, k = (f) => {
      h == null || h(f);
    }, D = () => {
      v == null || v();
    };
    return s.on(l.SignalConnected, m).on(l.MediaDevicesError, P).on(l.EncryptionError, S).on(l.Disconnected, k).on(l.Connected, D), () => {
      s.off(l.SignalConnected, m).off(l.MediaDevicesError, P).off(l.EncryptionError, S).off(l.Disconnected, k).off(l.Connected, D);
    };
  }, [
    s,
    p,
    y,
    g,
    c,
    E,
    b,
    v,
    h
  ]), i.useEffect(() => {
    if (s) {
      if (w) {
        s.simulateParticipants({
          participants: {
            count: w
          },
          publish: {
            audio: !0,
            useRealTracks: !0
          }
        });
        return;
      }
      if (a) {
        if (C.current = !0, u.debug("connecting"), !e) {
          u.debug("no token yet");
          return;
        }
        if (!o) {
          u.warn("no livekit url provided"), c == null || c(Error("no livekit url provided"));
          return;
        }
        s.connect(o, e, d).catch((m) => {
          u.warn(m), C.current === !0 && (c == null || c(m));
        });
      } else
        u.debug("disconnecting because connect is false"), C.current = !1, s.disconnect();
    }
  }, [
    a,
    e,
    JSON.stringify(d),
    s,
    c,
    o,
    w
  ]), i.useEffect(() => {
    if (s)
      return () => {
        u.info("disconnecting on onmount"), s.disconnect();
      };
  }, [s]), { room: s, htmlProps: F };
}
const W = /* @__PURE__ */ i.forwardRef(function(e, o) {
  const { room: t, htmlProps: r } = $(e);
  return /* @__PURE__ */ i.createElement("div", { ref: o, ...r }, t && /* @__PURE__ */ i.createElement(V.Provider, { value: t }, /* @__PURE__ */ i.createElement(j.Provider, { value: e.featureFlags }, e.children)));
});
export {
  W as L,
  G as a,
  H as c,
  M as m,
  T as r,
  $ as u,
  Q as w
};
//# sourceMappingURL=room-Bb6uLxS5.mjs.map
